import moment from 'moment';
import { DateFormats } from '../../constants/securspace-constants';
import { buyerInventoryCorrectionReport } from '../../../requests/api-endpoints';

const getInventoryCorrectionReportUrlParams = (requestParams, isPageable) => {

  const { page, size, startDate, endDate, locationId, orderNumber, sortBy, supplierName, equipmentType, equipmentNumber, driverName, sortDir } = requestParams;

  const params = isPageable ? new URLSearchParams([["page", page || 0], ["size", size || 10]]) : new URLSearchParams();

  if (startDate) {
    params.append("startDate", moment(startDate).format(DateFormats.DAY));
  }
  if (endDate) {
    params.append("endDate", moment(endDate).format(DateFormats.DAY));
  }
  if (locationId) {
    params.append("locationId", locationId)
  }
  if (orderNumber) {
    params.append("orderNumber", orderNumber)
  }
  if (sortBy && sortBy !== 'none') {
    params.append("sortBy", sortBy)
  }
  if (supplierName) {
    params.append("supplierName", supplierName?.trim())
  }
  if (equipmentType && equipmentType !== 'All') {
    params.append("equipmentType", equipmentType)
  }
  if (equipmentNumber) {
    params.append("equipmentNumber", equipmentNumber)
  }

  if (driverName) params.append("driverName", driverName);

  if (sortDir) {
    params.append("sortDir", sortDir)
  }

  return params;
}

export const getBuyerInventoryCorrectionReviewReportUrl = (searchParams) => {
  return `${buyerInventoryCorrectionReport.review}?${getInventoryCorrectionReportUrlParams(searchParams, true)}`;
}
